// TODO(parlato): Use this in vooma/ repo for auction emails
export const KNOWN_FREIGHT_PORTAL_DOMAINS = [
  '3gtms.com',
  'agistix.com',
  'archway.com',
  'carrierpoint.com',
  'chrobinson.com',
  'clearviewtmsemail.com',
  'coyotenotifications.com',
  'craneww.com',
  'efrexx.com',
  'email.portexpro.com',
  'emergemarket.io',
  'engagedtechnologies.com',
  'echo.com',
  'freightview.com',
  'graphicpkg.com',
  'mytmc.com',
  'mytmssystem.com',
  'optimus-steelusa.com',
  'PCSSoft.com',
  'ratelinx.com',
  'reconex.io',
  'rxo.com',
  'shipper.guide',
  'spreetail.com',
  'support.manh.com',
  't-insight.com',
  'tms.blujaysolutions.net',
  'tmx.princetontmx.com',
  'transactional.transfix.io',
  'transplace.com',
  'transporeon.com',
  'truckertools.com',
];
